import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
// mui
import { Box } from '@mui/material';
// component
import Loading from '../mui/Backdrop';
import SendBtn from './SendBtn';
import ComfirmSend from '@/component/send/ComfirmSend';
import { useChainId } from 'wagmi';
// hook
import { useWeb3 } from '@/hooks/use-web3';
// lib & store
import { useSendInfo } from '@/store/zustand/store';
import { telegramForm } from '@/lib/error-bot/telegram';
import { ethToWei } from '@/lib/web3/utils';
import { cutCommas } from '@/lib/util';
// type
import { SendContractType } from '@/types';
import { explorerUrlFilter } from '@/filter/explorerUrl';

export default function Erc20Token({ contractAddress, symbol }: { contractAddress: string; symbol: string }) {
  const navigate = useNavigate();
  const [isSubmit, setIsSubmit] = useState(false);
  const sendInfo = useSendInfo();
  const { web3authCall } = useWeb3();
  const [isSuccess, setIsSuccess] = useState(false);
  const txhash = useRef('');
  const [typeLogin, setTypeLogin] = useState('');
  const currentChainId = useChainId();

  useEffect(() => {
    if (isSubmit && web3authCall?.connected) {
      (async () => {
        try {
          const payload: SendContractType = {
            method: 'transfer',
            symbol: symbol.toUpperCase(),
            from: sendInfo.from,
            data: [sendInfo.to, ethToWei(cutCommas(sendInfo.value))],
          };
          const re = await web3authCall.getRpc().contractSend(payload);
          console.log(re);
          txhash.current = re;
          setIsSuccess(true);
          // re.transactionHash
        } catch (e) {
          console.log(e);
          const text = `type: erc20_usePrepareContractWrite(), fromAddr: ${sendInfo.from}, toAddr: ${sendInfo.to}, contract: 0x${contractAddress}, meg: ${JSON.stringify(e)}`;
          telegramForm(text);
          sendFail('전송실패');
          setIsSubmit(false);
        }
      })();
    }
  }, [isSubmit]);

  useEffect(() => {
    if (isSuccess) {
      navigate('/sendSuccess', {
        state: {
          type: 'erc20',
          data: {
            hash: txhash.current,
            blockExplorerUrl: explorerUrlFilter(currentChainId),
          },
        },
      });
    }
    return () => {};
  }, [isSuccess]);

  // const {
  //   config,
  //   status,
  //   isError: isPrepareError,
  //   error: prepareError,
  // } = usePrepareContractWrite({
  //   address: `0x${contractAddress}`, // 컨트랙트 주소
  //   abi: erc20ABI,
  //   functionName: 'transfer',
  //   args: [`0x${toAddr}`, parseEther(`${sendInfo.value}`)],
  //   cacheTime: 10000,
  // });
  // const { write, isLoading, isSuccess, isError, error, data } = useContractWrite(config);
  // const toAddr = '0x6c598cd7f49c40E8836C67b5C5B5A47EC2e7592F';
  // const { config } = usePrepareContractWrite({
  //   address: `0x${process.env.REACT_APP_TRI_CONTRACT}`, // 컨트랙트 주소
  //   abi: erc20ABI,
  //   functionName: 'transfer',
  //   args: [toAddr, parseEther('0.1')],
  // });
  // const { write } = useContractWrite(config);

  // useEffect(() => {
  //   if (isPrepareError) {
  //     const text = `type: erc20_usePrepareContractWrite(), fromAddr: ${sendInfo.from}, toAddr: ${toAddr}, contract: 0x${contractAddress}, meg: ${prepareError?.message}`;
  //     telegramForm(text);
  //     sendFail(prepareError?.message);
  //   }
  //   if (isError) {
  //     const text = `type: erc20_useContractWrite(), fromAddr: ${sendInfo.from}, toAddr: ${toAddr}, contract: 0x${contractAddress}, meg: ${error?.message}`;
  //     telegramForm(text);
  //     sendFail(error?.message);
  //   }

  //   return () => {};
  // }, [isPrepareError, isError]);

  // // 전송
  // useEffect(() => {
  //   if (isSubmit) {
  //     write?.();
  //   }
  //   return () => {};
  // }, [isSubmit]);

  const sendFail = (msg: string | undefined) => {
    navigate('/sendFail', {
      state: {
        data: msg,
      },
    });
  };
  return (
    <>
      <ComfirmSend type="erc20" symbol={symbol} />
      {isSubmit && (
        <>
          {typeLogin === 'external' ? (
            <Loading
              isLoading={isSubmit}
              text="사용할 전자지갑에서 전송 승인 완료 후 셔플을 실행하여 전송결과를 확인하세요."
            />
          ) : (
            <Loading isLoading={isSubmit} />
          )}
        </>
      )}

      <Box mb={5} />
      <SendBtn setIsSubmit={setIsSubmit} setTypeLogin={setTypeLogin} />
    </>
  );
}
